import {CognitoUserPool} from "amazon-cognito-identity-js";

const userPool = new CognitoUserPool({
    UserPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
});

export default userPool